<template>
  <div v-if="isHave" class="fixedBottom">
    <div v-for="(item, index) in progressList" :key="index">
      <div v-if="item" class="circle-wrapper">
        <a-badge :count="item?.count">
          <iconpark-icon
            :name="icons[index]"
            size="22"
            class="text-font-1 hover:text-primary"
            @click="showProgress(index)"
          ></iconpark-icon>
        </a-badge>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
const progressList = useProgress() || {}

const isHave = computed(
  () => progressList.value && Object.keys(progressList.value)?.length
)
// 进度相关图标
const icons = {
  download: 'video-download',
  publish: 'publish',
  rendering: 'render',
}

const showProgress = (index: any) => {
  setProgress(index, {
    show: true,
  })
}
</script>
<style lang="scss" scoped>
.fixedBottom {
  .circle-wrapper {
    @apply w-[48px] h-[48px] bg-back-1 rounded-[6px] cursor-pointer flex-y-center justify-center;
    box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.1);
    :deep(.ant-badge-count) {
      height: 16px;
      line-height: 16px;
      min-width: 16px;
      right: -6px;
      top: -6px;
    }
  }

  .circle-wrapper + .circle-wrapper {
    margin-top: 24px;
  }
}
</style>
